import Papa from 'papaparse';

type CsvCell = string | number | null | undefined;

type DownloadCsvRows = (params: {
  rows: CsvCell[][];
  filename: string;
  delimiter?: string;
}) => void;

const normalizeCsvCell = (value: CsvCell): CsvCell => {
  if (value === null || typeof value === 'undefined') return '';
  if (typeof value === 'number') return value;

  const normalized = String(value).trim();
  if (normalized === '') return '';

  if (/^(=|\+|-|@|DDE|\t|\n|\r)/.test(normalized)) {
    return "'" + normalized;
  }

  return normalized;
};

export const sanitizeFilename = (value?: string | null, fallback = 'export') => {
  const normalized = String(value || '')
    .trim()
    .replace(/[^a-z0-9]+/gi, '_')
    .replace(/^_+|_+$/g, '');

  return normalized || fallback;
};

export const downloadCsvRows: DownloadCsvRows = ({ rows, filename, delimiter = ',' }) => {
  const csvString = Papa.unparse(
    rows.map((row) => row.map(normalizeCsvCell)),
    { delimiter },
  );
  const anchor = document.createElement('a');
  anchor.href = 'data:attachment/csv;charset=utf-8,' + encodeURIComponent(csvString);
  anchor.target = '_blank';
  anchor.download = filename;
  anchor.click();
};
